import axios from "@/api/config_php";
// import qs from 'qs'
// 样例
export const demo = () => axios.get("app/demo");
